import React from 'react';
import { Box, Container, Typography, Link, useTheme } from '@mui/material';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'center', md: 'flex-start' } }}>
          <Box sx={{ mb: { xs: 2, md: 0 }, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="body2" color="inherit">
              © {currentYear} ThinkGPT AI Bookmarker. All rights reserved.
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 1, md: 3 }, alignItems: 'center' }}>
            <Link href="https://thinkodeai.com/Privacy-Policy.html" color="inherit" underline="hover">
              <Typography variant="body2" color="inherit">
                Privacy Policy
              </Typography>
            </Link>
            <Link href="https://thinkodeai.com/Terms-of-Service.html" color="inherit" underline="hover">
              <Typography variant="body2" color="inherit">
                Terms of Service
              </Typography>
            </Link>
            <Link href="https://thinkodeai.com/Contact.html" color="inherit" underline="hover">
              <Typography variant="body2" color="inherit">
                Contact Us
              </Typography>
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
